import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { RouterModule } from '@angular/router';

import { BreadcrumbComponent } from './breadcrumb.component';
import { MainMenuComponent } from './main-menu.component';


@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    RouterModule
  ],
  declarations: [
    MainMenuComponent,
    BreadcrumbComponent
  ],
  exports: [
    MainMenuComponent,
    BreadcrumbComponent
  ]
})
export class NavModule { }
